/*
 * 员工相关接口
 */
import request from '../request'
import { ILoginParams } from '../model'
export default class AjaxAuthService {
  /**
   * 登录
   * @param data
   * @returns
   */
  static login(data: ILoginParams): Promise<any> {
    return request.post('/user/login', data)
  }
  /**
   * uuid 登录
   * @param data
   * @returns
   */
  static getTokenByUuid(data: any): Promise<any> {
    return request.post('/user/getTokenByUuid', data)
  }
  /**
   * 退出登录
   * @returns
   */
  static logOut(): Promise<any> {
    return request.get('/user/loginOut')
  }
  /**
   * 查询树形菜单
   * @returns
   */
  static menu_treeMenuUser(data: any): Promise<any> {
    return request.get('/menu/treeMenuUser', data)
  }
  /**
   * 管理后台首页除折线图其他
   * @returns
   */
  static index_admin(data: any): Promise<any> {
    return request.post('/index/admin', data)
  }
  /**
   * 管理后台首页折线图
   * @returns
   */
  static orderTrend(data: any): Promise<any> {
    return request.post('/report/getOrderTrend', data)
  }
  /**
   * 今日派件
   * @returns
   */
  static todayDeliveryData(data: any): Promise<any> {
    return request.post('/report/todayDeliveryData', data)
  }
  /**
   * 快递公司占比
   * @returns
   */
  static getExpressProportion(data: any): Promise<any> {
    return request.post('/report/getExpressProportion', data)
  }
}
